module.exports = __webpack_public_path__ + "static/media/foundingBadge.27a7cdf9.png";